import React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { economicStore } from 'stores/EconomicStore';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore } from 'stores';

interface Props {
    fieldState: FieldState<any>
}

@observer class SelectCustomer extends React.Component<Props> {

    componentDidMount() {
        economicStore.getCustomers();
    }

    render() {
        const { fieldState } = this.props;
        const customers = economicStore.customers;

        const options = customers.map((customer) => ({
            value: customer.customerNumber,
            name: customer.name
        }))

        return (
            <ContractDropdownItem
                label={languageStore.get('customer')}
                placeholderText={languageStore.get('select')}
                id='economicId'
                fieldState={fieldState}
                options={options}
                editMode={true} />
        )
    }
}

export default SelectCustomer;